import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-environmental-sustainability',
  templateUrl: './environmental-sustainability.component.html',
  styleUrls: ['./environmental-sustainability.component.scss']
})
export class EnvironmentalSustainabilityComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Environmental Sustainability');
  }

}
